<template lang="pug">
  v-container
    v-col(cols="12")
      v-icon(style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
      h2.shops__title.shops__underline Mis tiendas
    v-container
      v-row(v-if="shops.length > 0").shop-list__container
        v-col(cols="4" v-for="shop in shops")
          .shop-list.justify-center(@click="gotoShop(shop.id)")
            img(:src="getImage(shop.pictures.imageInput1)").shop-list__img
            p.shop-list__title {{shop.name}}
      NoResults(v-else title="Aún no tienes tiendas", description="En esta sección encontraras tus tiendas")
</template>

<script>
  import shopPlaceHolder from '@/assets/icons/shop.svg'
  export default {

    components: {
      shopPlaceHolder: shopPlaceHolder,
      NoResults: () => import('@/components/custom/NoResults'),
    },

    data: () => ({
    }),

    computed: {
      shops () {
        return this.$store.getters['shops/getItems']
      },
    },

    methods: {
      getImage (url) {
        // console.log(url)
        if (url === '') {
          return shopPlaceHolder
        } else {
          return url
        }
      },
      gotoShop (id) {
        // console.log(id)
        const vm = this
        vm.$router.push(`shops/${id}`)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .shops {
    &__title {
      text-align: center;
      color:#a3a4a5;
      margin-bottom: 1.5rem;
    }

    &__underline {
      position: relative;

      &:after {
        content:' ';
        position: absolute;
        top:120%;
        left:50%;
        width: 8rem;
        border:2px solid #30b5bb;
        border-radius:4px;
        transform:translateX(-50%);
      }
    }
  }

  .shop-list {
    display: block;

    &__container {
      // margin: 0 .5rem;
      background: #fff;
      border-radius: 10px;
    }

    &__title {
      color: #c5c5c6;
      font-size: 0.8rem;
      text-align: center;
    }

    &__img {
      margin: auto;
      display: flex;
      height: 60px;
      width: 60px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
</style>
